import { render, staticRenderFns } from "./Individual.vue?vue&type=template&id=f58013d8&scoped=true"
import script from "./Individual.vue?vue&type=script&lang=js"
export * from "./Individual.vue?vue&type=script&lang=js"
import style1 from "./Individual.vue?vue&type=style&index=1&id=f58013d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58013d8",
  null
  
)

export default component.exports